import(/* webpackMode: "eager", webpackExports: ["CookiePolicyContent"] */ "/vercel/path0/apps/web/src/app/cookie-policy/cookie-policy-content.tsx");
